import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8 } from "styled-components";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import classNames from "classnames";
import { useEffect, useLayoutEffect, useRef } from "react";
import { sortable } from "react-anything-sortable";
import { useTranslation } from "react-i18next";
import styled, { useTheme } from "styled-components";
import Box from "../../Styled/Box";
import { RawButton } from "../../Styled/Button";
import Icon, { StyledIcon } from "../../Styled/Icon";
import Ul from "../../Styled/List";
import Spacing from "../../Styled/Spacing";
import Text, { TextSpan } from "../../Styled/Text";
import parseCustomHtmlToReact from "../Custom/parseCustomHtmlToReact";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const findTextContent = content => {
  if (typeof content === "string") {
    return content;
  }
  if (content[0] && content[0].props && content[0].props.children) {
    return findTextContent(content[0].props.children);
  }
  if (!content.props || !content.props.children) {
    return "";
  }
  if (typeof content.props.children === "string") {
    return content.props.children;
  }
  return findTextContent(content.props.children);
};
const StoryControl = styled(Box).attrs({
  centered: true,
  left: true,
  justifySpaceBetween: true
}).withConfig({
  displayName: "Story__StoryControl",
  componentId: "sc-4vaybl-0"
})([""]);
const StoryMenuButton = styled(RawButton).withConfig({
  displayName: "Story__StoryMenuButton",
  componentId: "sc-4vaybl-1"
})(["color:", ";background-color:", ";", "{width:35px;}svg{fill:", ";width:18px;height:18px;}border-radius:0;width:124px;min-height:32px;display:block;&:hover,&:focus{color:", ";background-color:", ";svg{fill:", ";stroke:", ";}}"], props => props.theme.textDarker, props => props.theme.textLight, StyledIcon, props => props.theme.textDarker, props => props.theme.textLight, props => props.theme.colorPrimary, props => props.theme.textLight, props => props.theme.textLight);
const hideList = props => props.closeMenu();
const getTruncatedContent = text => {
  const content = parseCustomHtmlToReact(text);
  const except = findTextContent(content);
  return except.slice(0, 100);
};
const toggleMenu = props => event => {
  event.stopPropagation();
  props.openMenu();
};
const viewStory = props => event => {
  event.stopPropagation();
  props.viewStory();
  hideList(props);
};
const deleteStory = props => event => {
  event.stopPropagation();
  props.deleteStory();
  hideList(props);
};
const editStory = props => event => {
  event.stopPropagation();
  props.editStory();
  hideList(props);
};
const recaptureStory = props => event => {
  event.stopPropagation();
  props.recaptureStory();
  hideList(props);
};
const StoryMenu = props => {
  const {
    t
  } = useTranslation();
  const menuRef = useRef(null);
  useLayoutEffect(() => {
    // Adjust the position of the menu so it stays inside the scroll container.

    if (!menuRef.current) return;
    if (!props.parentRef.current) return;

    // Grow downwards, by default:
    Object.assign(menuRef.current.style, {
      top: "0px",
      bottom: "unset"
    });
    const selfRect = menuRef.current.getBoundingClientRect();
    const parentRect = props.parentRef.current.getBoundingClientRect();
    if (selfRect.bottom > parentRect.bottom) {
      // Looks like there's no room to the bottom; grow upwards.
      Object.assign(menuRef.current.style, {
        top: "unset",
        bottom: "0px"
      });
    }
  }, [props.parentRef]);
  return /*#__PURE__*/_jsx(_StyledBox, {
    ref: menuRef,
    children: /*#__PURE__*/_jsxs(Ul, {
      column: true,
      children: [/*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(StoryMenuButton, {
          onClick: viewStory(props),
          title: t("story.viewStory"),
          children: /*#__PURE__*/_jsxs(StoryControl, {
            children: [/*#__PURE__*/_jsx(StyledIcon, {
              glyph: Icon.GLYPHS.viewStory
            }), /*#__PURE__*/_jsx("span", {
              children: t("story.view")
            })]
          })
        })
      }), /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(StoryMenuButton, {
          onClick: editStory(props),
          title: t("story.editStory"),
          children: /*#__PURE__*/_jsxs(StoryControl, {
            children: [/*#__PURE__*/_jsx(StyledIcon, {
              glyph: Icon.GLYPHS.editStory
            }), /*#__PURE__*/_jsx("span", {
              children: t("story.edit")
            })]
          })
        })
      }), /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(StoryMenuButton, {
          onClick: recaptureStory(props),
          title: t("story.recaptureStory"),
          children: /*#__PURE__*/_jsxs(StoryControl, {
            children: [/*#__PURE__*/_jsx(StyledIcon, {
              glyph: Icon.GLYPHS.story
            }), /*#__PURE__*/_jsx("span", {
              children: t("story.recapture")
            })]
          })
        })
      }), /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(StoryMenuButton, {
          onClick: deleteStory(props),
          title: t("story.deleteStory"),
          children: /*#__PURE__*/_jsxs(StoryControl, {
            children: [/*#__PURE__*/_jsx(StyledIcon, {
              glyph: Icon.GLYPHS.cancel
            }), /*#__PURE__*/_jsx("span", {
              children: t("story.delete")
            })]
          })
        })
      })]
    })
  });
};
const Story = props => {
  const story = props.story;
  const bodyText = getTruncatedContent(story.text);
  const theme = useTheme();
  const {
    t
  } = useTranslation();
  const storyRef = useRef(null);
  const closeHandler = () => {
    hideList(props);
  };
  useEffect(() => {
    window.addEventListener("click", closeHandler);
    return () => window.removeEventListener("click", closeHandler);
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(_StyledBox2, {
      ref: storyRef,
      column: true,
      backgroundColor: theme.darkWithOverlay,
      rounded: true,
      style: props.style,
      className: classNames(props.className),
      onMouseDown: props.onMouseDown,
      onTouchStart: props.onTouchStart,
      children: [/*#__PURE__*/_jsxs(_StyledBox3, {
        fullWidth: true,
        justifySpaceBetween: true,
        padded: true,
        verticalCenter: true,
        styledHeight: "57px",
        backgroundColor: theme.darkWithOverlay,
        rounded: true,
        children: [/*#__PURE__*/_jsxs(_StyledDiv, {
          children: [/*#__PURE__*/_jsx(_StyledTextSpan, {
            medium: true,
            bold: true,
            children: props.index + 1
          }), /*#__PURE__*/_jsx(_StyledTextSpan2, {
            overflowEllipsis: true,
            textLight: true,
            medium: true,
            children: story.title && story.title.length > 0 ? story.title : t("story.untitledScene")
          })]
        }), /*#__PURE__*/_jsxs(Box, {
          children: [props.recaptureStorySuccessful && /*#__PURE__*/_jsx(RawButton, {
            children: /*#__PURE__*/_jsx(_StyledStyledIcon, {
              styledWidth: "20px",
              light: true,
              glyph: Icon.GLYPHS.recapture
            })
          }), /*#__PURE__*/_jsx(MenuButton, {
            theme: theme,
            onClick: toggleMenu(props),
            children: /*#__PURE__*/_jsx(StyledIcon, {
              styledWidth: "20px",
              light: true,
              glyph: Icon.GLYPHS.menuDotted
            })
          })]
        }), props.menuOpen && /*#__PURE__*/_jsx(StoryMenu, _objectSpread(_objectSpread({}, props), {}, {
          storyRef: storyRef
        }))]
      }), bodyText.length > 0 && /*#__PURE__*/_jsx(Box, {
        paddedRatio: 2,
        paddedHorizontally: 3,
        children: /*#__PURE__*/_jsx(_StyledText, {
          overflowEllipsis: true,
          textLight: true,
          medium: true,
          children: bodyText
        })
      })]
    }), /*#__PURE__*/_jsx(Spacing, {
      bottom: 3
    })]
  });
};
const MenuButton = styled(RawButton).withConfig({
  displayName: "Story__MenuButton",
  componentId: "sc-4vaybl-2"
})(["padding:0 10px 0 10px;min-height:40px;border-radius:", ";background:transparent;&:hover,&:focus{opacity:0.9;background-color:", ";}"], props => props.theme.radiusSmall, props => props.theme.dark);
export default sortable(Story);
var _StyledBox = styled(Box).withConfig({
  displayName: "Story___StyledBox",
  componentId: "sc-4vaybl-3"
})(["position:absolute;z-index:100;right:0px;padding:0;margin:0;ul{list-style:none;}"]);
var _StyledBox2 = styled(Box).withConfig({
  displayName: "Story___StyledBox2",
  componentId: "sc-4vaybl-4"
})(["cursor:move;float:none !important;border:1px solid #baebf8;"]);
var _StyledBox3 = styled(Box).withConfig({
  displayName: "Story___StyledBox3",
  componentId: "sc-4vaybl-5"
})(["padding-left:15px;padding-right:0;border-bottom:1px solid rgba(255,255,255,0.15);"]);
var _StyledDiv = styled("div").withConfig({
  displayName: "Story___StyledDiv",
  componentId: "sc-4vaybl-6"
})(["width:100%;overflow-x:hidden;display:flex;"]);
var _StyledTextSpan = styled(TextSpan).withConfig({
  displayName: "Story___StyledTextSpan",
  componentId: "sc-4vaybl-7"
})(["color:#baebf8;margin-right:8px;"]);
var _StyledTextSpan2 = styled(TextSpan).withConfig({
  displayName: "Story___StyledTextSpan2",
  componentId: "sc-4vaybl-8"
})(["overflow-x:hidden;white-space:nowrap;"]);
var _StyledStyledIcon = styled(StyledIcon).withConfig({
  displayName: "Story___StyledStyledIcon",
  componentId: "sc-4vaybl-9"
})(["padding-right:10px;"]);
var _StyledText = styled(Text).withConfig({
  displayName: "Story___StyledText",
  componentId: "sc-4vaybl-10"
})(["overflow-x:hidden;white-space:nowrap;"]);